import HeaderTextLink from './HeaderTextLink';

export default HeaderTextLink;
